import { FC } from "react";
import Modal from "@Components/Modal";
import styles from "./mapModalStyles.module.scss";
import Portal from "@Components/Portal";
import useIsDesktop from "hooks/useIsDesktop";

export const MapModalV3: FC<any> = ({ onClose, title, children }) => {
  const isDesktop = useIsDesktop();
  return (
    <Portal>
      <Modal
        title={title}
        className={styles.mapModalStyles}
        hideModal={onClose}
        zIndex={400}
        isHistoryPush={!isDesktop}
      >
        {children}
      </Modal>
    </Portal>
  );
};

export default MapModalV3;
